<template lang="pug">
div
  ul#cmstab.nav.nav-tabs(role='tablist')
    template(v-if="showActionButton('gamifyoperator')")
      li.nav-item(@click="refresh('gamifyoperator')")
        a#gamifyoperator-tab.nav-link(:class="{ 'active': currTab == 'gamifyoperator' }" data-toggle='tab' href='#gamifyoperator-content' role='tab' aria-controls='gamifyoperator' aria-selected='false') {{ $t("ui.gamification") }}
    template(v-if="showActionButton('rewardrain')")
      li.nav-item(@click="refresh('rewardrain')")
        a#rewardrain-tab.nav-link(:class="{ 'active': currTab == 'rewardrain' }" data-toggle='tab' href='#rewardrain-content' role='tab' aria-controls='rewardrain' aria-selected='false') {{ $t("ui.reward_rain") }}

  #cmstabcontent.tab-content.tab-bordered
    template(v-if="showActionButton('cms')")
      #gamifyoperator-content.tab-pane(:class="{ 'active show': currTab == 'gamifyoperator' }" role='tabpanel' aria-labelledby='gamifyoperator-tab')
        gamifyOperatorTab(ref="gamifyOperatorTab" :currTab="currTab")
    template(v-if="showActionButton('rewardrain')")
      #rewardrain-content.tab-pane.fade(:class="{ 'active show': currTab == 'rewardrain' }" role='tabpanel' aria-labelledby='rewardrain-tab')
        rewardRainTab(ref="rewardRainTab")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import gamifyOperatorTab from "@/components/rewardTab/gamifyOperatorTab.vue";
import rewardRainTab from "@/components/rewardTab/rewardRainTab.vue";

export default {
  components: {
    gamifyOperatorTab,
    rewardRainTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'gamifyoperator'
  }),
  computed: {
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    }
  },
  mounted: function() {  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'gamifyoperator':
          this.tabChecking();
          break
        case 'rewardrain':
          this.currTab = 'rewardrain'
          if(this.$refs.rewardRainTab) {
            this.$refs.rewardRainTab.refresh();
          }
          break
      }
    },
    tabChecking() {
      if(this.showActionButton('gamifyoperator')) {
        this.currTab = 'gamifyoperator'
        this.$nextTick(() => {
          if(this.$refs.gamifyOperatorTab) {
            this.$refs.gamifyOperatorTab.refresh();
          }
        });
      } else if(this.showActionButton('rewardrain')) {
        this.currTab = 'rewardrain'
        this.$nextTick(() => {
          if(this.$refs.rewardRainTab) {
            this.$refs.rewardRainTab.refresh();
          }
        });
      }
    }
  }
};
</script>